import React from "react";
import { Printer } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "controls";

const Header = ({ access }) => {
  const navigate = useNavigate();
  const handlePrintLabel = () => {
    navigate("/inquiry_form");
  };

  return (
    access?.inquery?.create && (
      <Button
        onClick={handlePrintLabel}
        startIcon={<Printer className="h-[20px] w-[20px]" />}
      >
        Add Inquiry
      </Button>
    )
  );
};

export default Header;
